import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import store from "../store/provider";
import {
  localizeMessage,
  willLocalize,
  translationsReady,
} from "./localizeMessage";
toast.configure();

const OPTIONS = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const Toast = (type, data) => {
  // Cold deep-links can fire data errors before the boot translations fetch lands;
  // hold covered messages briefly instead of flashing raw English.
  if (type === "error" && willLocalize(data) && !translationsReady()) {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      unsubscribe();
      toast(localizeMessage(data), { type, ...OPTIONS });
    };
    // store.subscribe fires on EVERY dispatch, not just translations landing —
    // only release once translations are actually populated; the timer caps the
    // wait and localizeMessage falls back to the raw message if they never load.
    const unsubscribe = store.subscribe(() => {
      if (translationsReady()) finish();
    });
    const timer = setTimeout(finish, 2000);
    return;
  }
  return toast(localizeMessage(data), { type, ...OPTIONS });
};
